import { FormInstance, message } from 'antd';
import { RolePermissionType } from 'permission/role/type/roleType';
import { NavigateFunction } from 'react-router-dom';
import { accountStore } from 'store/accountStore';
import { userService } from '../service/userService';
import { UserInterface } from '../types/userType';

interface UserAddHandlersProps {
  form: FormInstance;
  navigate: NavigateFunction;
}

interface UserAddHandlersReturn {
  onFinish: () => Promise<void>;
}

export const getUserAddHandlers = ({
  form,
  navigate,
}: UserAddHandlersProps): UserAddHandlersReturn => {
  const onFinish = async (): Promise<void> => {
    const platform = accountStore.getAccount()!.platform;
    const loadingMessage = message.loading('Creating...', 0);
    try {
      const values = await form.validateFields();
      const newUser: UserInterface = {
        id: -1,
        username: values.username,
        email: values.email,
        first_name: values.first_name,
        last_name: values.last_name,
        platform: platform,
      };

      if (values.company) {
        newUser.company = values.company;
        newUser.company_id = values.company.id;
      }

      const createdUser = await userService.creatUserWithRole(
        newUser,
        values.roles.map((role: RolePermissionType) => role.id)
      );
      loadingMessage();
      navigate('/user', {
        state: {
          message: '사용자가 성공적으로 생성되었습니다',
          userId: createdUser.id,
        },
      });
    } catch (error) {
      loadingMessage();
      message.error('Failed to create : ' + error);
    }
  };

  return {
    onFinish,
  };
};
